import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule, MatInputModule, MatSnackBar  } from '@angular/material';
import { HelpHttpService } from '../../../../core/help';

@Component({
  selector: 'kt-add-remarks-dialog',
  templateUrl: './add-remarks-dialog.component.html',
  styleUrls: ['./add-remarks-dialog.component.scss']
})
export class AddRemarksDialogComponent implements OnInit{

	remarks: string = '';


  constructor( public dialogRef: MatDialogRef<AddRemarksDialogComponent>, private http: HelpHttpService, private _snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

	qParams = {};
	remarksData;

	ngOnInit() {
		this.getRemarks();
	}

	getRemarks(){
		this.qParams = {
			ticket_no: this.data.element.ticket_no
		}
		this.http.getHelpRemarks(this.qParams)
		.subscribe((remarks: any) => {
		  this.remarksData = remarks;

		if (this.remarksData && this.remarksData.length > 0) {
		this.remarks = this.remarksData[0].remarks;
		}

		// console.log("REMARKS:",this.remarksData);
		});
	}

	onCancel(): void {
		this.dialogRef.close();
		// console.log("DATAAA", this.data.element.ticket_no);
	  }

	onSave(): void {
		this.dialogRef.close(this.remarks);

		let obj = {
			ticketNo: this.data.element.ticket_no,
			remark: this.remarks
		}

		this.http.saveRemarks(obj)
			.subscribe(resp => {
			console.log(resp);
			this.showSnackBar("Remarks Saved Successfully", 3000);
		}, error => {
			console.log(error);
			this.showSnackBar(error, 3000);
		});
	}

	showSnackBar(message: string, duration: number) {
		let snackRef = this._snackBar.open(message, 'close');
		if (duration > 0) {
			setTimeout(() => {
				this._snackBar.dismiss();
			}, duration);
		}

		snackRef.onAction().subscribe(() => {
			this._snackBar.dismiss();
		});
	}

}
